export default __webpack_public_path__ + "63824b5d4565bb60564a44c7cee5f001.png";